import { useMemo } from "react";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { MealPlanAPIPromiseClient } from "../../../../gen/witbooking/backoffice/mealplan/v1/mealplan_api_grpc_web_pb";
import {
  GetAllMealPlansRequest,
  MealPlan,
} from "../../../../gen/witbooking/backoffice/mealplan/v1/mealplan_api_pb";

export type MealPlanObject = MealPlan.AsObject;

export function useMealPlanApi() {
  const grpcClient = useGrpcClient(MealPlanAPIPromiseClient);
  const getAllMealPlans = usePropertyGrpcCall(grpcClient, grpcClient.getAllMealPlans);

  return useMemo(
    () => ({
      getAllMealPlans: async (propertyTicker: string) => {
        const request = new GetAllMealPlansRequest();
        request.setPropertyTicker(propertyTicker);
        const response = await getAllMealPlans(request);
        return response.getMealPlansList().map(it => it.toObject());
      },
    }),
    [getAllMealPlans]
  );
}
